import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import ReactDOM from 'react-dom'
import * as UserActions from '../actions/user'
import { FormattedMessage } from 'react-intl';
import * as CartActions from '../actions/cart';
import * as DocumentStorageActions from '../actions/documentStorage';

class App extends React.Component {

    constructor(props, context) {
        super(props, context);

        // React components using ES6 classes no longer autobind this to non React methods. In your constructor, add:
        this.openLoginModal = this.openLoginModal.bind(this);
        this.closeLoginModal = this.closeLoginModal.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
    };

    openLoginModal() {
        let { dispatch } = this.props;
        dispatch(UserActions.openLoginModal());
    }

    closeLoginModal() {
        let { dispatch } = this.props;
        dispatch(UserActions.closeLoginModal());
    }

    handleLogin(event) {
        event.preventDefault();
        let formData = {
            username: ReactDOM.findDOMNode(this.refs.username).value,
            password: ReactDOM.findDOMNode(this.refs.password).value
        };

        let { dispatch } = this.props;
        dispatch(UserActions.doLogin(formData.username, formData.password));
    }

    componentWillMount() {
        let { dispatch } = this.props;
        dispatch(UserActions.getUserStatus());
        dispatch(CartActions.getCart());
    }

    render() {

        let { user, location, cart, intl } = this.props;


        let section = <div></div>;

        // Set here innerHTML outside from react-root
        // TODO ... find a better solution to handle dom manipulation outsite of the react-root
        let navbarUser = '';
        let navbarProfile = '';
        let navbarLogout = '';
        let navbarCart = '';
        let navbarLeft = '<li><a href="/#/dashboard"><i class="material-icons">home</i></a></li>';

        if (user.username) {
            navbarUser ='<span class="bolder">' + user.username + '</span>';
            navbarLogout = '<a href="#/logout"><i class="material-icons">exit_to_app</i></a>';
            document.getElementById('mainfooter').classList.add("app-loaded");
        } else {
            document.getElementById('mainfooter').classList.remove("app-loaded");
        }
        document.getElementById('navbarUser').innerHTML = navbarUser;
        document.getElementById('navbarProfile').innerHTML = navbarProfile;
        document.getElementById('navbarLogout').innerHTML = navbarLogout;
        document.getElementById('navbarLeft').innerHTML = navbarLeft; // will be also handled in the Configurator.react.jsx

        if (user.username || location.pathname === '/logout') {
            section = <section className="container">
                {this.props.children}
            </section>
        }

        if (user.username && cart && cart.loaded === true) {
            const cartCount = cart.data.printshopPrintable.length + cart.data.userPrintable.length;
            const cartMsg = cartCount > 0 ? '*' : '';
            const cartIcon = cartCount > 0 ? 'add_shopping_cart' : 'shopping_cart';
            const cartCountClass = cartCount > 0 ? 'visible' : '';
            navbarCart = '<li><a href="/#/cart">' +
                '<i class="material-icons">' + cartIcon + '</i><span id="navbarCartCount" class="' + cartCountClass + '">' +
                cartMsg + '</span></a></li>'
        }
        document.getElementById('navbarCart').innerHTML = navbarCart;

        // create the serverLocale by current locale from intl
        let serverLocale = 'en_GB';
        if (intl.locale) {
            serverLocale = intl.locale.replace(/-/,'_'); // de-DE -> de_DE
        }

        return (
            <div>

                {section}

                <Modal
                    className="Modal__Bootstrap modal-dialog"
                    closeTimeoutMS={150}
                    isOpen={user.showLoginModal && (location.pathname !== '/logout')}
                    onRequestClose={this.closeLoginModal}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={this.closeLoginModal}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only"><FormattedMessage id="LABEL_CLOSE" /></span>
                            </button>
                            <h4 className="modal-title"><FormattedMessage id="LABEL_LOGIN" /></h4>
                        </div>

                        <form className="form-horizontal" role="form" onSubmit={event => this.handleLogin(event)}>
                        <div className="modal-body">
                            <p className="bg-danger" style={{display: user.loginError ? 'block' : 'none'}}><FormattedMessage id="ERROR_LOGIN" /></p>
                            <div className="form-group">
                                <label className="control-label col-sm-2" for="username"><FormattedMessage id="LABEL_EMAIL" /></label>
                                <div className="col-sm-10">
                                <input type="text" className="form-control" id="username" ref="username"/>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="control-label col-sm-2" for="username"><FormattedMessage id="LABEL_PASSWORD" /></label>
                                <div className="col-sm-10">
                                    <input type="password" className="form-control" id="password" ref="password"/>
                                </div>
                            </div>
                            <p>
                                <FormattedMessage id="LOGIN_DESCRIPTION" />&nbsp;
                                <a className="llink" href={ serverLocale + "/register" }><FormattedMessage id="REGISTER_LINK" /></a>
                            </p>
                            <p>
                                <a className="llink" href={ serverLocale + "/resetting/request" }><FormattedMessage id="RESET_PASSWORD" /></a>
                            </p>
                            <p>
                                <a className="llink" href={ "https://posmaterial.paulaner.de/saml/login" } >Single Sign On</a>
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-primary" onClick={event => this.handleLogin(event)}><FormattedMessage id="LABEL_LOGIN" /></button>
                        </div>
                    </form>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default connect(state => ({ user: state.user, app: state.app, cart: state.cart, intl: state.intl }))(App);



// WEBPACK FOOTER //
// ./src/js/components/App.react.jsx